// All action times

const contacts = {
  REQUEST_USER_LIST: 'REQUEST_USER_LIST',
  RECEIVE_USER_LIST: 'RECEIVE_USER_LIST',
  SERVER_ERROR_OCURED: 'SERVER_ERROR_OCURED',
  REQUEST_USER_LIST_DETAILS: 'REQUEST_USER_LIST_DETAILS',
  RECEIVE_USER_LIST_DETAILS: 'RECEIVE_USER_LIST_DETAILS',
  CLEAR_ERRORS: 'CLEAR_ERRORS'
};

export default contacts;



// WEBPACK FOOTER //
// src/routes/Users/actions/actiontypes.js